<template>
  <section
    class="w-full mx-auto flex flex-col flex-1 overflow-y-auto overflow-x-hidden transition-all box-border pt-0 md:pt-20">
    <span class="container sm:mb-[-63px] max-w-5xl mx-auto px-10">
      <Titre textePrincipal="Nos " texteAccentue="adoptés&nbsp;(es)" :isSidebarOpen="isSidebarOpen" />
    </span>
    <div class="w-full text-pink-500 mx-auto px-10 text-xl sm:text-2xl md:text-3xl">
      <BarChart :chart-data="chartData2026" chart-title="2026" />
      <BarChart :chart-data="chartData2025" chart-title="2025" />
      <BarChart :chart-data="chartData2024" chart-title="2018-2024" />
      <BarChart :chart-data="chartData2012_2017" chart-title="2012-2017" />
    </div>
  </section>
</template>

<script setup>
import { defineAsyncComponent } from 'vue';
import Titre from '../composants/Titre.vue';
import { isSidebarOpen } from '../store/storeSideBar.js';
import LoadingSpinner from '../composants/LoadingSpinner.vue';
import ErrorComponent from '../composants/ErrorComponent.vue';

// Importation des composants pour les graphiques
const BarChart = defineAsyncComponent({
  loader: () => import('../composants/BarChart.vue'),
  loadingComponent: LoadingSpinner,
  errorComponent: ErrorComponent,
  delay: 200,
  timeout: 3000,
});

// Données pour 2026
const chartData2026 = {
  labels: ['Janv. / Févr.', 'Mars / Avr.', 'Mai / Juin', 'Juil. / Août', 'Sept. / Oct.', 'Nov. / Déc.'],
  datasets: [
    {
      label: 'Adoptions',
      backgroundColor: '#2f8faa',
      data: [65, 42, 48, 42, 48, ''],
      borderColor: '#2f8faa',
      borderWidth: 1,
      hoverBackgroundColor: '#43a7c3',
    },
  ],
};


// Données pour 2025
const chartData2025 = {
  labels: ['Janv. / Févr.', 'Mars / Avr.', 'Mai / Juin', 'Juil. / Août', 'Sept. / Oct.', 'Nov. / Déc.'],
  datasets: [
    {
      label: 'Adoptions',
      backgroundColor: '#2f8faa',
      data: [60, 43, 36, 49, 57, 59],
      borderColor: '#2f8faa',
      borderWidth: 1,
      hoverBackgroundColor: '#43a7c3',
    },
  ],
};

// Données pour 2018-2024
const chartData2024 = {
  labels: ['2018', '2019', '2020', '2021', '2022', '2023', '2024'],
  datasets: [
    {
      label: 'Adoptions',
      backgroundColor: '#66BB6A',
      data: [364, 319, 364, 283, 227, 231, 264],
      borderColor: '#2faa61',
      borderWidth: 1,
      hoverBackgroundColor: '#acfccc',
    },
  ],
};

// Données pour 2012-2017
const chartData2012_2017 = {
  labels: ['2012', '2013', '2014', '2015', '2016', '2017'],
  datasets: [
    {
      label: 'Adoptions',
      backgroundColor: '#66BB6A',
      data: [5, 29, 188, 299, 385, 504],
      borderColor: '#2faa61',
      borderWidth: 1,
      hoverBackgroundColor: '#acfccc',
    },
  ],
};

</script>
